import { Button } from "@common/index";
import styles from "./styles.module.scss";
import imgOld from "./img/imgOld.png";
import imgYoung from "./img/imgYoung.png";
import { useSelector } from "react-redux";


export const WalkingReduce = ({ onNextStep, onTrackEvent }) => {
  const userOnboardAge = localStorage.getItem("userOnboardAge");
  const ageStart = localStorage.getItem("ageStart");

  const userYoung = userOnboardAge
    ? userOnboardAge <= 44
      ? true
      : false
    : ageStart === "18-29" || ageStart === "30-39"
    ? true
    : false;

  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <div className={styles.imageContainer}>
          <img
            src={userYoung ? imgYoung : imgOld}
            alt="slimdown"
            className={styles.image}
          />
        </div>
        <div className={styles.hints}>
          <h4>
            Walking can reduce the risk of cardiovascular diseases by 33%{" "}
          </h4>
          <br />A study in the Journal of Physical Activity and Health revealed
          that regular walking can greatly cut metabolic syndrome risks for
          older adults.
        </div>
      </div>
      <div className={styles.action}>
        <Button
          variant="walky"
          onClick={() => {
            onNextStep();
            onTrackEvent();
          }}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
